<template>
  <v-app id="App">
    <router-view id="router"></router-view>
    <Loading :isLoading="this.$store.state.loader.loading" />
    <Snackbar
      :content="this.$store.state.snackbar.content"
      :visible="this.$store.state.snackbar.visible"
      :color="this.$store.state.snackbar.color"
    />
  </v-app>
</template>

<script>
import Loading from "./views/components/Loading";
import Snackbar from "./views/components/Snackbar";
require("dotenv/config");

export default {
  name: "App",

  components: {
    Loading,
    Snackbar
  },
  created() {
    this.$http.interceptors.request.use(
      (config) => {
        this.$store.dispatch("loader/show");
        return config;
      },
      (error) => {
        this.$store.dispatch("loader/hide");
        return Promise.reject(error);
      }
    );

    this.$http.interceptors.response.use(
      (response) => {
        this.$store.dispatch("loader/hide");
        return response;
      },
      (error) => {
        this.$store.dispatch("loader/hide");
        return Promise.reject(error);
      }
    );

    //STAGING
    this.$shttp.interceptors.request.use(
      (config) => {
        this.$store.dispatch("loader/show");
        return config;
      },
      (error) => {
        this.$store.dispatch("loader/hide");
        return Promise.reject(error);
      }
    );

    this.$shttp.interceptors.response.use(
      (response) => {
        this.$store.dispatch("loader/hide");
        return response;
      },
      (error) => {
        this.$store.dispatch("loader/hide");
        return Promise.reject(error);
      }
    );
  }
};
</script>

<style scoped></style>
